<template class="ml-3">
	<div class="mx-3">
		<v-flex class="mx-4 rounded-lg">
			<v-tabs
				v-model="tab"
				:background-color="theme.primary"
				:color="theme.accent"
				class="elevation-2 mt-5 mx-auto"
				dark
				centered
				grow
				:slider-color="theme.accent"
			>
				<v-tabs-slider></v-tabs-slider>
				<v-tab href="#course">Course</v-tab>
				<v-tab href="#quiz">Quiz</v-tab>

				<v-tab-item value="course">
					<v-container class="mx-auto">
						<v-row class="main-content-container mx-auto">
							<v-col class="mb-4 col-lg-8 col-12">
								<v-card class="mx-auto" max-width="100%">
									<div class="px-4">
										<v-card-title>Create course </v-card-title>

										<v-col>
											<v-select
												class="pl-2 max-200"
												:cols="3"
												:items="subjects"
												item-text="name"
												item-value="id"
												label="Subject"
												v-model="form.course.subject"
											></v-select>
										</v-col>

										<v-card
											class="elevation-3 ma-4 mt-0 mb-7 px-3"
											v-for="(i, index) in form.course.body"
											v-bind:key="index"
											max-width="100%"
										>
											<div class="pa-5">
												<v-col>
													<v-flex row>
														<v-select
															class="max-200"
															:cols="3"
															:items="content_types"
															item-text="name"
															item-value="id"
															label="Type"
															v-model="form.course.body[index].type"
															@change="form.course.body[index].content = null"
														></v-select>
														<v-spacer></v-spacer>
														<v-hover class="cursor-pointer">
															<template v-slot="{ hover }">
																<v-icon
																	:class="`elevation-${hover ? 0 : 3}`"
																	class="transition-swing rounded-circle ml-2 pa-2 close-icon"
																	:color="theme.primary"
																	dark
																	size="20"
																	@click="deleteSection(index)"
																	>mdi-close</v-icon
																>
															</template>
														</v-hover>
													</v-flex>
												</v-col>
												<v-col v-if="form.course.body[index].type == 'TEXT'">
													<v-textarea
														rows="3"
														name="input-6-1"
														label="Content"
														v-model="form.course.body[index].content"
														hint="Please ensure your text is clear and precise"
													></v-textarea>
												</v-col>

												<v-col v-if="form.course.body[index].type == 'IMAGE'">
													<v-file-input
														:rules="[
															value =>
																!value ||
																value.size < 500000 ||
																'Image size should be less than 500KB',
														]"
														v-model="form.course.body[index].temp_content"
														@change="extractImage(index)"
														accept="image/*"
														show-size
														placeholder="Select image"
														solo
													></v-file-input>
												</v-col>
												<v-col v-if="form.course.body[index].type == 'LIST'">
													<v-flex
														row
														v-for="(item, inner_index) in form.course.body[
															index
														].content"
														v-bind:key="inner_index"
													>
														<v-textarea
															name="input-7-1"
															label="Content"
															rows="1"
															v-model="
																form.course.body[index].content[inner_index]
															"
															hint="Please ensure your text is clear and precise"
														>
														</v-textarea>
														<v-spacer></v-spacer>
														<v-hover class="cursor-pointer">
															<template v-slot="{ hover }">
																<v-icon
																	:class="`elevation-${hover ? 0 : 3}`"
																	class="transition-swing rounded-circle ml-2 pa-2 close-icon-small"
																	:color="theme.accent"
																	dark
																	size="15"
																	@click="deleteListItem(index, inner_index)"
																	>mdi-close</v-icon
																>
															</template>
														</v-hover>
													</v-flex>
													<v-row align="center" justify="center">
														<v-hover class="mx-2 my-5 cursor-pointer">
															<template v-slot="{ hover }">
																<v-btn
																	:class="`elevation-${hover ? 0 : 3}`"
																	:color="theme.primary"
																	dark
																	text
																	class="text-capitalize transition-swing rounded-lg"
																	@click="addItemToList(index)"
																>
																	<v-icon size="20" class="ml-2"
																		>mdi-plus</v-icon
																	>
																	Add item
																</v-btn>
															</template>
														</v-hover>
													</v-row>
												</v-col>
											</div>
										</v-card>

										<v-row align="center" justify="center">
											<v-hover class="mx-2 my-10 cursor-pointer">
												<template v-slot="{ hover }">
													<v-btn
														:class="`elevation-${hover ? 0 : 3}`"
														:color="theme.primary"
														dark
														text
														class="text-capitalize transition-swing rounded-lg"
														@click="addCourseSection"
													>
														<v-icon size="20" class="ml-2">mdi-plus</v-icon>
														Add section
													</v-btn>
												</template>
											</v-hover>
										</v-row>

										<v-card-actions class="justify-end">
											<v-btn
												class="mt-2 text-capitalize"
												:color="theme.primary"
												@click="goUp"
												width="120"
												depressed
												text
											>
												<v-icon class="mr-2">mdi-chevron-up</v-icon>
												Go up
											</v-btn>
										</v-card-actions>
									</div>
								</v-card>
							</v-col>
							<v-col class="mb-4 col-md-4">
								<v-card class="mx-auto px-4 pb-5" max-width="100%">
									<v-col>
										<v-text-field
											label="Course name"
											v-model="form.course.name"
										></v-text-field>
										<v-select
											:cols="4"
											:items="Array.from(Array(8).keys()).map(i => i + 5)"
											label="Grade"
											v-model="form.course.grade"
										></v-select>
										<v-select
											:cols="4"
											:items="Array.from(Array(5).keys()).map(i => i + 1)"
											label="Difficulty"
											v-model="form.course.difficulty"
										></v-select>
										<v-text-field
											label="Youtube video ID (Optional)"
											v-model="form.course.video_id"
										></v-text-field>
										<v-text-field
											label="Duration (in minutes)"
											v-model="form.course.duration"
											hide-details
											single-line
											min="0"
											max="200"
											type="number"
										/>
									</v-col>

									<v-card-subtitle class="font-small"
										>Course will be added as
										<b>{{ user.school.name }}</b></v-card-subtitle
									>

									<v-card-actions class="mx-auto">
										<v-btn
											class="white--text mt-2 text-capitalize"
											:color="theme.primary"
											@click="createCourse"
											width="100%"
											depressed
											:disabled="can_submit_course == false"
										>
											Submit
											<v-icon class="mr-2">mdi-chevron-right</v-icon>
										</v-btn>
									</v-card-actions>
								</v-card>
							</v-col>
						</v-row>
					</v-container>
				</v-tab-item>
				<v-tab-item value="quiz">
					<v-container class="mx-auto">
						<v-row class="main-content-container mx-auto">
							<v-col class="mb-4 col-lg-8 col-12">
								<v-card class="mx-auto" max-width="100%">
									<div class="px-4">
										<v-card-title>Create quiz </v-card-title>
										<v-col>
											<v-select
												class="pl-2 max-200"
												:cols="3"
												:items="subjects"
												item-text="name"
												item-value="id"
												label="Subject"
												v-model="form.quiz.subject"
											></v-select>
										</v-col>

										<v-card
											class="elevation-3 ma-4 mt-0 mb-7 px-3"
											v-for="(i, index) in form.quiz.questions"
											v-bind:key="index"
											max-width="100%"
										>
											<div class="pa-5">
												<v-col>
													<v-flex row>
														<v-select
															class="max-200"
															:cols="2"
															:items="question_types"
															item-text="name"
															item-value="id"
															label="Type"
															v-model="form.quiz.questions[index].type"
															@change="questionTypeChanged(index)"
														></v-select>
														<v-spacer></v-spacer>
														<v-hover class="cursor-pointer">
															<template v-slot="{ hover }">
																<v-icon
																	:class="`elevation-${hover ? 0 : 3}`"
																	class="transition-swing rounded-circle ml-2 pa-2 close-icon"
																	:color="theme.primary"
																	dark
																	size="20"
																	@click="deleteQuestion(index)"
																	>mdi-close</v-icon
																>
															</template>
														</v-hover>
													</v-flex>
												</v-col>
												<v-textarea
													rows="2"
													name="input-6-1"
													label="Question"
													v-model="form.quiz.questions[index].question"
													hint="Please ensure your question is clear and precise"
												></v-textarea>

												<template
													v-if="form.quiz.questions[index].type == 'FILL'"
												>
													<v-textarea
														rows="1"
														name="input-6-1"
														label="Answer"
														v-model="form.quiz.questions[index].answer"
													></v-textarea>
												</template>
												<template
													v-if="form.quiz.questions[index].type == 'TRUEFALSE'"
												>
													<div fluid>
														<v-radio-group
															label="Answer"
															v-model="form.quiz.questions[index].answer"
															column
														>
															<v-radio
																size="3"
																ripple
																class="font-small mt-2"
																label="True"
																:value="true"
															></v-radio>
															<v-radio
																size="3"
																ripple
																class="font-small"
																label="False"
																:value="false"
															></v-radio>
														</v-radio-group>
													</div>
												</template>
												<template
													v-if="form.quiz.questions[index].type == 'RANK'"
												>
													<draggable
														v-model="form.quiz.questions[index]['answer']"
														class="pt-2 draggable"
													>
														<transition-group>
															<v-card
																:elevation="0"
																class="max-500 cursor-pointer"
																v-for="item in form.quiz.questions[index][
																	'answer'
																]"
																v-bind:key="item"
																:value="
																	form.quiz.questions[index][`option_${item}`]
																"
																ghost-class="ghost"
															>
																<v-hover>
																	<template v-slot="{ hover }">
																		<div
																			:class="`elevation-${hover ? 3 : 0}`"
																			class="transition-swing rounded-lg pa-3 font-small ma-2 mx-0 truncated-text draggable-card"
																		>
																			<v-icon
																				class="mr-2 float-left col-lightgrey"
																				>mdi-drag</v-icon
																			>
																			<v-text-field
																				:name="`Option ${item}`"
																				:label="`Rank ${item[item.length - 1]}`"
																				v-model="
																					form.quiz.questions[index][item]
																				"
																				required
																			></v-text-field>
																		</div>
																	</template>
																</v-hover>
															</v-card>
														</transition-group>
													</draggable>

													<v-alert type="info" class="font-small mt-2" dense>
														Please drag to rearrange the options. This will be
														the order shown to the students
													</v-alert>
												</template>

												<template
													v-if="form.quiz.questions[index].type == 'SELECTONE'"
												>
													<div fluid>
														<v-radio-group
															v-model="form.quiz.questions[index].answer"
															column
														>
															<v-flex
																class="px-3"
																row
																v-for="i in [1, 2, 3, 4]"
																v-bind:key="i"
															>
																<v-text-field
																	:name="`Option ${i}`"
																	:label="`Option ${i}`"
																	v-model="
																		form.quiz.questions[index][`option_${i}`]
																	"
																	required
																></v-text-field>
																<v-spacer></v-spacer>
																<v-radio
																	size="3"
																	ripple
																	class="font-small"
																	:value="
																		form.quiz.questions[index][`option_${i}`]
																	"
																></v-radio>
															</v-flex>
														</v-radio-group>
													</div>
												</template>
												<template
													v-if="
														form.quiz.questions[index].type == 'SELECTMULTIPLE'
													"
												>
													<div fluid>
														<v-flex
															class="px-3"
															row
															v-for="i in [1, 2, 3, 4]"
															v-bind:key="i"
														>
															<v-text-field
																:name="`Option ${i}`"
																:label="`Option ${i}`"
																v-model="
																	form.quiz.questions[index][`option_${i}`]
																"
																required
															></v-text-field>
															<v-spacer></v-spacer>
															<v-checkbox
																size="3"
																ripple
																class="font-small"
																:value="`option_${i}`"
																@change="ensureArray(index)"
																v-model="form.quiz.questions[index]['answer']"
															></v-checkbox>
														</v-flex>
													</div>
												</template>
												<v-text-field
													label="Tip"
													v-model="form.quiz.questions[index]['tip']"
												></v-text-field>
											</div>
										</v-card>

										<v-row align="center" justify="center">
											<v-hover class="mx-2 my-10 cursor-pointer">
												<template v-slot="{ hover }">
													<v-btn
														:class="`elevation-${hover ? 0 : 3}`"
														:color="theme.primary"
														dark
														text
														class="text-capitalize transition-swing rounded-lg"
														@click="addQuestion"
													>
														<v-icon size="20" class="ml-2">mdi-plus</v-icon>
														Add question
													</v-btn>
												</template>
											</v-hover>
										</v-row>

										<v-card-actions class="justify-end">
											<v-btn
												class="mt-2 text-capitalize"
												:color="theme.primary"
												@click="goUp"
												width="120"
												depressed
												text
											>
												<v-icon class="mr-2">mdi-chevron-up</v-icon>
												Go up
											</v-btn>
										</v-card-actions>
									</div>
								</v-card>
							</v-col>
							<v-col class="mb-4 col-md-4">
								<v-card class="mx-auto px-4 pb-5" max-width="100%">
									<v-col>
										<v-text-field
											label="Quiz name"
											v-model="form.quiz.name"
										></v-text-field>
										<v-select
											:cols="4"
											:items="Array.from(Array(8).keys()).map(i => i + 5)"
											label="Grade"
											v-model="form.quiz.grade"
										></v-select>
										<v-select
											:cols="4"
											:items="Array.from(Array(5).keys()).map(i => i + 1)"
											label="Difficulty"
											v-model="form.quiz.difficulty"
										></v-select>
										<v-text-field
											label="Duration (in minutes)"
											v-model="form.quiz.duration"
											hide-details
											single-line
											min="0"
											max="200"
											type="number"
										/>
									</v-col>

									<v-card-subtitle class="font-small"
										>Quiz will be added as
										<b>{{ user.school.name }}</b></v-card-subtitle
									>

									<v-card-actions class="mx-auto">
										<v-btn
											class="white--text mt-2 text-capitalize"
											:color="theme.primary"
											@click="createQuiz"
											width="100%"
											depressed
											:disabled="can_submit_quiz == false"
										>
											Submit
											<v-icon class="mr-2">mdi-chevron-right</v-icon>
										</v-btn>
									</v-card-actions>
								</v-card>
							</v-col>
						</v-row>
					</v-container>
				</v-tab-item>
			</v-tabs>
		</v-flex>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import draggable from 'vuedraggable'
export default {
	name: 'Create',
	components: {
		draggable,
	},

	data: () => ({
		content_types: [
			{ id: 'TEXT', name: 'Text' },
			{
				id: 'IMAGE',
				name: 'Image',
			},
			{
				id: 'LIST',
				name: 'List',
			},
		],
		question_types: [
			{ id: 'SELECTONE', name: 'Select One' },
			{
				id: 'RANK',
				name: 'Rank',
			},
			{
				id: 'SELECTMULTIPLE',
				name: 'Select Multiple',
			},
			{
				id: 'FILL',
				name: 'Fill in the Gap',
			},
			{
				id: 'TRUEFALSE',
				name: 'True or False',
			},
		],
		form: {
			course: null,
			quiz: null,
		},
		subjects: [],
		tab: null,
	}),

	created() {
		this.refreshCourse()
		this.refreshQuiz()
	},

	mounted() {
		if (this.user.is_admin === false) {
			this.setAlert("You don't have access to this feature.")
			this.$router.push({ name: 'Dashboard' })
		}

		this.core.http
			.get('subjects')
			.then(response => {
				this.subjects = response.data.subjects
			})
			.catch(error => {
				this.setAlert(error.response)
			})
	},
	methods: {
		...mapMutations(['setAlert', 'forceLoad']),
		ensureArray(index) {
			if (this.form.quiz.questions[index]['answer'] == null)
				this.form.quiz.questions[index]['answer'] = []
		},
		questionTypeChanged(index) {
			if (this.form.quiz.questions[index].type == 'SELECTMULTIPLE')
				this.form.quiz.questions[index].answer = []
			else if (this.form.quiz.questions[index].type == 'RANK')
				this.form.quiz.questions[index].answer = [
					'option_1',
					'option_2',
					'option_3',
					'option_4',
				]
			else this.form.quiz.questions[index].answer = null
		},
		addQuestion() {
			this.form.quiz.questions.push({
				question: null,
				type: 'SELECTONE',
				answer: null,
				tip: null,
			})
		},
		deleteQuestion(index) {
			this.form.quiz.questions.splice(index, 1)
		},
		createQuiz() {
			this.core.http
				.post('quizzes', this.form.quiz)
				.then(response => {
					response.link = {
						link: { name: 'Quiz', params: { id: response.data.quiz.id } },
						label: 'View quiz',
					}
					this.setAlert(response)
					this.refreshQuiz()
				})
				.catch(error => {
					this.setAlert(error.response)
				})
		},
		extractImage(index) {
			this.getBase64(this.form.course.body[index].temp_content, base64Data => {
				this.form.course.body[index].content = base64Data
			})
		},

		deleteSection(index) {
			this.form.course.body.splice(index, 1)
		},

		deleteListItem(index, inner_index) {
			this.form.course.body[index].content.splice(inner_index, 1)
		},

		addItemToList(index) {
			if (
				typeof this.form.course.body[index].content == 'string' ||
				this.form.course.body[index].content == null
			)
				this.form.course.body[index].content = []
			this.form.course.body[index].content.push('')
		},

		addCourseSection() {
			this.form.course.body.push({
				type: 'TEXT',
				content: null,
			})
		},
		goUp() {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth',
			})
		},
		formatDuration(duration) {
			let format = 'HH[h] mm[m]'
			if (duration < 60) format = 'mm[m]'

			return this.core.moment
				.utc(this.core.moment.duration(duration, 'minutes').asMilliseconds())
				.format(format)
		},
		goToCourse(course_id) {
			this.$router.push({ name: 'Course', params: { id: course_id } })
		},
		goToQuiz(quiz_id) {
			this.$router.push({ name: 'Quiz', params: { id: quiz_id } })
		},
		getBase64(file, callback) {
			const reader = new FileReader()
			reader.addEventListener('load', () => callback(reader.result))
			reader.readAsDataURL(file)
		},
		createCourse() {
			this.core.http
				.post('course', this.form.course)
				.then(response => {
					response.link = {
						link: { name: 'Course', params: { id: response.data.course.id } },
						label: 'View course',
					}
					this.setAlert(response)
					this.refreshCourse()
				})
				.catch(error => {
					this.setAlert(error.response)
				})
		},
		refreshCourse() {
			this.form.course = {
				name: null,
				subject: null,
				body: [
					{
						type: 'TEXT',
						content: null,
					},
				],
				duration: null,
				difficulty: null,
				grade: null,
				video_id: null,
			}
		},
		refreshQuiz() {
			this.form.quiz = {
				name: null,
				subject: null,
				questions: [
					{
						type: 'SELECTONE',
						question: null,
						answer: null,
						tip: null,
					},
				],
				duration: null,
				difficulty: null,
				grade: null,
			}
		},
	},
	computed: {
		...mapGetters(['loading', 'theme', 'user']),
		can_submit_course: function() {
			return Object.keys(this.form.course).every(f => {
				if (f == 'body') {
					return this.form.course.body.every(s => {
						if (s.type == 'TEXT') return s.content != null && s.content != ''
						if (s.type == 'IMAGE') return s.content != null
						if (s.type == 'LIST')
							return s.content.every(l => l != '' && l != null)
					})
				}
				if (['video_id'].includes(f) == false)
					return this.form.course[f] != null && this.form.course[f] != ''

				return true
			})
		},
		can_submit_quiz: function() {
			return Object.keys(this.form.quiz).every(f => {
				if (f == 'questions') {
					return this.form.quiz.questions.every(q => {
						if (['TRUEFALSE', 'FILL'].includes(q.type))
							return (
								((q.answer != null && q.answer != '') ||
									(typeof q.answer == 'boolean' && q.type == 'TRUEFALSE')) &&
								q.question != null &&
								q.question != '' &&
								q.tip != null &&
								q.tip != ''
							)
						if (['SELECTONE', 'SELECTMULTIPLE'].includes(q.type)) {
							return (
								q.answer != null &&
								q.answer != '' &&
								q.answer != [] &&
								q.option_1 != null &&
								q.option_1 != '' &&
								q.option_2 != null &&
								q.option_2 != '' &&
								q.option_3 != null &&
								q.option_3 != '' &&
								q.option_4 != null &&
								q.option_4 != '' &&
								q.question != null &&
								q.question != '' &&
								q.tip != null &&
								q.tip != ''
							)
						}
						if (['RANK'].includes(q.type)) {
							return (
								q.option_1 != null &&
								q.option_1 != '' &&
								q.option_2 != null &&
								q.option_2 != '' &&
								q.option_3 != null &&
								q.option_3 != '' &&
								q.option_4 != null &&
								q.option_4 != '' &&
								q.question != null &&
								q.question != '' &&
								q.tip != null &&
								q.tip != ''
							)
						}
					})
				}
				return this.form.quiz[f] != null && this.form.quiz[f] != ''
			})
		},
	},

	watch: {},

	beforeDestroy: function() {
		this.forceLoad(false)
	},
}
</script>

<style scoped>
.content-wrapper {
	display: inline-block;
	width: 300px;
}
.subject-box {
	height: 120px;
	background-color: white;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	background-size: cover;
}
.subject-box div {
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	color: white;
	padding-top: 45px;
	font-size: 1.5rem;
	color: white;
	background-color: rgba(0, 0, 0, 0.6);
	height: 100%;
}
.body-card:hover {
	cursor: pointer;
}
.content-holder {
	/* width: 100%; */
	height: 320px;
	overflow-x: scroll;
	overflow-y: hidden;
	white-space: nowrap;
	-webkit-overflow-scrolling: touch;
}
::-webkit-scrollbar {
	width: 0px;
	background: transparent;
}
.card-title {
	font-size: 0.9rem !important;
}
.chip-active {
	color: #1d1641 !important;
	background-color: #e8e5f6 !important;
}
.course-name {
	width: 270px;
}
.custom-truncate::after {
	content: ' ...';
	position: absolute;
	right: 0;
	margin-right: 15px;
}
.absolute-right {
	position: absolute;
	right: 0;
}
.max-200 {
	max-width: 200px !important;
}
.draggable {
	cursor: pointer;
}
.draggable-card {
	border: 1px solid lightgrey;
	max-width: 500px;
}
.close-icon {
	max-height: 35px;
}
.close-icon-small {
	max-height: 30px;
}
</style>
